const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** Converts milliseconds to whole days, truncating toward zero (1 day = 24 h, arithmetic). */
export function millisecondsToDays(ms: number): number {
  return Math.trunc(ms / MS_PER_DAY);
}
